import axios from '@/utils/axios'
import {business, doctorPrefix} from '../../common'

/**
 * 获取医生信息
 * @param NotNeedErrorMessage
 */
export const getDoctorInfo = (NotNeedErrorMessage = false) => {
  return axios({
    url: `${business}${doctorPrefix}/tenant/doctor/getUserInfo`,
    headers: {
      ...(NotNeedErrorMessage ? {'NotNeedErrorMessage': true} : {})
    },
    method: 'get'
  })
}

/**
 * 获取诊所信息
 */
export const getClinicInfo = clinicCode => {
  return axios({
    url: `${business}${doctorPrefix}/tenant/clinic/clinicInfo`,
    method: 'get',
    params: {clinicCode}
  })
}

/**
 * 修改医生信息
 * @param form
 */
export const editTenantDoctor = form => {
  return axios({
    url: `${business}${doctorPrefix}/tenant/doctor/editTenantDoctor`,
    method: 'post',
    data: form
  })
}

/**
 * 统计医案数量
 */
export const recordStatistics = () => {
  return axios({
    url: `${business}${doctorPrefix}/tenant/medical/recordStatistics `,
    method: 'get'
  })
}

/**
 * 获取云诊365用户绑定状态
 */
export const queryYz365BindState = (data) => {
  return axios({
    url: `${business}${doctorPrefix}/tenant/doctor/queryYz365BindState`,
    headers: {
      'NotShowProgress': true
    },
    method: 'get',
    params: data
  })
}

/**
 * 修改云诊365用户绑定状态
 */
export const updateYz365BindState = (data) => {
  return axios({
    url: `${business}${doctorPrefix}/tenant/doctor/updateYz365BindState`,
    data: data,
    method: 'post'
  })
}

/**
 * 统计医案疾病
 */
export const diseaseStatisticList = (param) => {
  return axios({
    url: `${business}${doctorPrefix}/medical/record/statistic/diseaseList`,
    method: 'get',
    params: param
  })
}

/**
 * 分页查询医案疾病信息
 */
export const diseasePage = (pageInfo, params) => {
  return axios({
    url: `${business}${doctorPrefix}/medical/record/statistic/diseasePage`,
    method: 'post',
    data: pageInfo,
    params: params
  })
}

/**
 * 统计医案疾病性别年龄
 */
export const genderAgeRangeDiseaseStatisticList = (param) => {
  return axios({
    url: `${business}${doctorPrefix}/medical/record/statistic/genderAgeRangeDiseaseList`,
    method: 'get',
    params: param
  })
}

/**
 * 统计医案证型
 */
export const conclusionStatisticList = (param) => {
  return axios({
    url: `${business}${doctorPrefix}/medical/record/statistic/conclusionList`,
    method: 'get',
    params: param
  })
}

/**
 * 分页查询医案证型信息
 */
export const conclusionPage = (pageInfo, params) => {
  return axios({
    url: `${business}${doctorPrefix}/medical/record/statistic/conclusionPage`,
    method: 'post',
    data: pageInfo,
    params: params
  })
}

/**
 * 统计医案证型性别年龄
 */
export const genderAgeRangeConclusionStatisticList = (param) => {
  return axios({
    url: `${business}${doctorPrefix}/medical/record/statistic/genderAgeRangeConclusionList`,
    method: 'get',
    params: param
  })
}

/**
 * 获取知症辨证配置的症状数据
 */
export const getAllDiseaseSymptom = () => {
  return axios({
    url: `${business}${doctorPrefix}/tenant/config/diseaseSymptom/all`,
    method: 'get'
  })
}

/**
 * 问题反馈
 * @param params
 * @returns {AxiosPromise}
 */
export const problemFeedback = (params) => {
  return axios({
    url: `${business}${doctorPrefix}/tenant/doctor/problemFeedback`,
    method: 'post',
    data: params
  })
}



// WEBPACK FOOTER //
// ./src/api/business/doctor/index.js